<template>
    <el-dialog title="调整组队" :visible.sync="visible" width="60%" :append-to-body="true" :modal-append-to-body="false"
        @close="visible = false" class="tablechose">
        <div style="margin-bottom:30px;font-size:12px;color:#858585">
            调整方式：可拖动一行数据至任意位置，即可实现排序号调整，签位号对应发生变化
        </div>
        <div class="table-header">
            <div>排序号</div>
            <div>姓名</div>
            <div>会员账号</div>
            <div>账户属性</div>
            <div>性别</div>
            <div>年龄</div>
        </div>
        <div class="table-box">
            <div class="sort-box">
                <div v-for="(item, index) in tableList" :key="index" :class="[computedClass(item.sortNo, index)]">{{
                    computedSortNo(item.sortNo, index) }}</div>
            </div>
            <div class="list-box">
                <div v-for="item in tableList" :key="item.id" draggable="true" class="list">
                    <div>{{ item.name }}</div>
                    <div>{{ item.mobile }}</div>
                    <div>{{ item.accountTypeName }}</div>
                    <div>{{ item.gender ? (item.gender == '0' ? '男' : '女') : '' }}</div>
                    <div>{{ item.age }}</div>
                </div>
            </div>
        </div>
        <el-button @click="comfirmClick" :disabled="confirmBtn" type="primary" class="Submit">提交修改</el-button>
    </el-dialog>
</template>
<script>
import Sortable from 'sortablejs'
export default {
    //   name: "AdjustGameSys",
    data() {
        return {
            loading: true,
            visible: false,
            enrollDataOne: [],
            list: [],
            tableList: [],
            sortable: null,
            enrollData: [],
            enrollDataTwo: [],
            changeList: [],
            table: {
                data: []
            },
            ctId: '',
            confirmBtn: false,
        }
    },
    mounted() { },
    computed: {
        computedSortNo() {
            return function (sortNo, index) {
                if (index > 0 && sortNo === this.tableList[index - 1].sortNo) {
                    return ''
                }
                return sortNo
            }
        },
        computedClass() {
            return function (sortNo, index) {
                if (index < this.tableList.length - 1 && sortNo === this.tableList[index + 1].sortNo) {
                    return 'sort-bottom'
                }
                return ''
            }
        }
    },
    methods: {
        openFullScreen() {
            this.loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
        },
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                const tableData = this.list;
                if (rowIndex > 0 && tableData[rowIndex][column.property] === tableData[rowIndex - 1][column.property]) {
                    return 'aaa';
                }
                if (rowIndex < tableData.length - 1 && tableData[rowIndex][column.property] === tableData[rowIndex + 1][column.property]) {
                    return 'bbb';
                }
                return 'ccc'
            }
        },
        init(id) {
            this.ctId = id
            this.list = []
            this.tableList = []
            this.visible = true
            this.$http({
                url: this.$http.adornUrl(`/elEnroll/getDoubleMatchEnrollListByCtId?ctId=${id}&teamType=1`),
                method: 'get'
            }).then((data) => {
                this.loading = false
                if (data && data.code == 0) {
                    data.data.forEach(item => {
                        if (item.elEnrollList.length < 2) {
                            item.elEnrollList.push({})
                        }
                        item.elEnrollList.forEach(ele => {
                            ele.sortNo = item.sortNo;
                            if (ele.accountType) {
                                ele.accountTypeName = ele.accountType == 0 ? '一般账户' : '青少年账户'
                            }
                            this.list.push(ele)
                        })
                    })
                    this.list.forEach(item => {
                        this.tableList.push({ ...item })
                        // this.tableList.push({ name: item.name, mobile: item.mobile, accountTypeName: item.accountTypeName, gender: item.gender, age: item.age, sortNo: item.sortNo })
                    })
                    this.confirmBtn = this.list.length == 0 ? true : false
                }
            })
            this.$nextTick(() => {
                const listBox = document.querySelector('.list-box')
                let sourceNode = null
                let targetNode = null

                listBox.ondragstart = e => {
                    setTimeout(() => {
                        e.target.classList.add('moving')
                    }, 0)
                    sourceNode = e.target
                }

                listBox.ondragend = e => {
                    if (!sourceNode || !targetNode) return
                    e.target.classList.remove('moving')
                    const children = [...listBox.children]
                    // 拿到下标
                    const sourceIndex = children.indexOf(sourceNode)
                    const targetIndex = children.indexOf(targetNode)
                    console.log(sourceNode, targetNode);
                    console.log('sourceIndex', sourceIndex, 'targetIndex', targetIndex);

                    // 创建两个临时占位元素
                    const temp1 = document.createElement('div');
                    const temp2 = document.createElement('div');

                    // 用临时元素替换要交换的元素
                    listBox.replaceChild(temp1, sourceNode);
                    listBox.replaceChild(temp2, targetNode);

                    // 交换元素位置
                    listBox.insertBefore(sourceNode, temp2);
                    listBox.insertBefore(targetNode, temp1);

                    // 移除临时元素
                    listBox.removeChild(temp1);
                    listBox.removeChild(temp2);
                    this.swapByindexes(this.list, sourceIndex, targetIndex)
                }

                listBox.ondragenter = e => {
                    if (!sourceNode) return
                    if (e.target.parentNode === listBox || e.target.parentNode === sourceNode) return
                    targetNode = e.target.parentNode
                }
            })

        },
        swapByindexes(list, oldIndex, newIndex) {
            let arr = []
            arr = arr.concat(list)

            const sortNo = arr[newIndex].sortNo
            arr[newIndex].sortNo = arr[oldIndex].sortNo
            arr[oldIndex].sortNo = sortNo

            const sortal = arr[newIndex]
            arr[newIndex] = arr[oldIndex]
            arr[oldIndex] = sortal
            setTimeout(() => {
                this.list = arr
            }, 50)
        },
        // 确定
        comfirmClick() {
            const groupedMap = new Map();
            // 遍历数组，根据 sortNo 进行分组
            this.list.forEach(item => {
                if (!groupedMap.has(item.sortNo)) {
                    groupedMap.set(item.sortNo, []);
                }
                groupedMap.get(item.sortNo).push(item);
            });
            // 将 Map 转换为数组格式
            const data = Array.from(groupedMap, ([sortNo, items]) => ({
                sortNo,
                elEnrollList: items.map(item => {
                    // 创建一个新对象，排除 sortNo 属性
                    const { sortNo: _, ...rest } = item; // 使用解构赋值和扩展运算符
                    return rest;
                })
            }));
            console.log(data);
            data.forEach(item => {
                for (let i = 0; i < item.elEnrollList.length; i++) {
                    if (JSON.stringify(item.elEnrollList[i]) === '{}') {
                        item.elEnrollList.splice(i, 1)
                        i--
                    }
                }
            })
            this.confirmBtn = true
            this.$showLoading()
            this.$http({
                url: this.$http.adornUrl(`/elEnroll/changeDoubleMatch/${this.ctId}`),
                method: 'post',
                data
            }).then((data) => {
                if (data.code == 0) {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 300,
                        onClose: () => {
                            this.$emit('refreshSortFormatrList')
                            this.visible = false
                        }
                    })
                    this.$showLoading('close')
                } else {
                    this.confirmBtn = false
                }
            }).catch(() => {
                this.confirmBtn = false
            })

        },
    }
}
</script>
<style scoped>
.tablechose {
    position: relative;
}

.Submit {
    position: absolute;
    right: 50px;
    top: 10px;
}

::v-deep .el-table__body-wrapper tbody>tr.hover-row>td {
    background-color: transparent !important;
}

::v-deep .el-table__body-wrapper tbody>tr.hover-row>td {
    background-color: transparent !important;
}

::v-deep .el-table__body-wrapper tbody>tr:hover {
    background-color: #F5F7FA !important;
}

::v-deep .aaa {
    background-color: transparent !important;
    transition: all 0.3s;
}

::v-deep .aaa .cell {
    opacity: 0;
    transition: all 0.3s;
}

::v-deep .ccc {
    background-color: transparent !important;
    transition: all 0.3s;

}


::v-deep .bbb {
    border-bottom: none;
    background-color: transparent !important;
    transition: all 0.3s;

}

::v-deep .bbb .cell {
    transform: translateY(100%);
    transition: all 0.3s;
}

.table-header {
    display: flex;
    border-top: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
}

.table-header div {
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-weight: bold;
    color: #909399;
    border-left: 1px solid #EBEEF5;
}

.table-header div:not(:first-child) {
    flex: 1;
}

.table-header div:first-child {
    box-sizing: border-box;
    width: 80px;
}

.table-box {
    display: flex;
}

.sort-box {
    width: 80px;
    border-top: 1px solid #EBEEF5;
}

.sort-box div {
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-left: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
}

.sort-box .sort-bottom {
    line-height: 98px;
    border-bottom-color: transparent;
}

.list-box {
    flex: 1;
    border-top: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
}

.list {
    line-height: 48px;
    display: flex;
    border-bottom: 1px solid #EBEEF5;
    border-left: none;
}

.list div {
    flex: 1;
    min-height: 48px;
    text-align: center;
    border-left: 1px solid #EBEEF5;
}

.list.moving {
    background-color: #F5F7FA;
}
</style>